"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOptionalDef = void 0;
const parseDef_1 = require("../parseDef");
const parseOptionalDef = (def, refs) => {
    if (refs.currentPath.toString() === refs.propertyPath.toString()) {
        return (0, parseDef_1.parseDef)(def.innerType._def, refs);
    }
    const innerSchema = (0, parseDef_1.parseDef)(def.innerType._def, refs.addToPath("anyOf", "1"));
    return innerSchema
        ? {
            anyOf: [
                {
                    not: {},
                },
                innerSchema,
            ],
        }
        : {};
};
exports.parseOptionalDef = parseOptionalDef;
